export const TRANSLATED_ROUTES_QUICKSHIP_PAGE = {
  es: {
    route: "productos/quickship",
  },
  en: {
    route: "products/quickship",
  },
};
